import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'
import { videos } from 'src/constants/videos'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { selectParams } from 'src/modules/reducers/params'
import { promoCodes } from 'src/constants'
import { PlanIntervals } from 'src/constants/planData'

export default (props) => {
  const params = useSelector(selectParams)

  const [validReferrer, setValidReferrer] = React.useState(false)
  React.useEffect(() => {
    const docReferrer = document && document.referrer
    // Gating for https://rewards.bing.com/redirect?link=https%3A%2F%2Fwww.fubo.tv%2Fstream%2Fca%2Fmicrosoft-rewards%2F&id=ENCA_hack_Fubo_Offer_082025&channel=urlreward&hash=1f8292c54f29c2ffae3161c09ed9983ee1ec7b621ad5f08c7c85fb8ae6f3832d
    if (docReferrer && docReferrer.includes('rewards.bing.com')) {
      setValidReferrer(true)
    }
  }, [params])

  const offerBanner = validReferrer
    ? {
        title: [
          'Special offer for Microsoft Rewards Members.',
          'Get a 10-day free trial + $30 off your first Quarter.',
        ],
      }
    : {
        title: [
          'Offer Not Applied.',
          'Please revisit this page from the offer on the Microsoft Rewards website.',
        ],
      }

  return (
    <StyledContainer>
      <CanadaTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        video={videos.seasonal_ca.videoUrl}
        videoMobile={videos.seasonal_ca.videoMobileUrl}
        annotations={videos.seasonal_ca.annotations}
        title="Watch live sports & entertainment"
        subtitle={
          <>
            Enjoy top leagues, <span className="mobile-line-break"> popular TV shows & more </span>
          </>
        }
        networkSet="canadaEssentials"
        hasPlanCardsTabs={true}
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-microsoft-rewards_v4.png?w=650&ch=width&auto=format,compress"
        logoHeight="46px"
        offerBanner={offerBanner}
        offerCode={validReferrer ? promoCodes.microsoft_rewards : null}
        planCardsConfig={{
          plans: [canadaPlanData.sports],
          overrides: {
            sports: {
              quarterly: {
                discountedPrice: 53.97,
                savingsNote: '$10 off',
                offerCode: promoCodes.microsoft_rewards,
              },
            },
          },
          activeTab: PlanIntervals.quarterly,
          hideTabs: true,
        }}
        forceAnchorLink={false}
        noIndex={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 600px;
  }
`
